<ngx-smart-modal
  #deleteConfirmationModal
  identifier="deleteConfirmationModal"
  customClass="anflex-modal dimmed delete-confirmation-modal"
  (onAnyCloseEvent)="emitCancelEvent()"
>
  <div class="anflex-modal-container">
    <div class="anflex-modal-header">
      <h3 class="anflex-modal-title">Delete {{ objectName | titlecase }}</h3>
    </div>
    <div class="anflex-modal-body">
      <p *ngIf="isGroup" class="anflex-modal-body-message">
        {{ messageGroupTemplate }}
      </p>
      <p *ngIf="!isGroup" class="anflex-modal-body-message">
        {{ messageObjectTemplate }}
      </p>
    </div>

    <div class="anflex-modal-footer">
      <button (click)="emitDeleteEvent()" class="btn-primary active">Delete</button>
      <button (click)="emitCancelEvent()" class="btn-primary">Cancel</button>
    </div>
  </div>
</ngx-smart-modal>
